module["exports"] = [
  "back up",
  "bypass",
  "hack",
  "override",
  "compress",
  "copy",
  "navigate",
  "index",
  "connect",
  "generate",
  "quantify",
  "calculate",
  "synthesize",
  "input",
  "transmit",
  "program",
  "reboot",
  "parse"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/hacker/verb.js
// module id = 392
// module chunks = 0